(ns machtfit.stepchall.onboarding
  (:require [machtfit.stepchall.modal :as modal]
            [machtfit.stepchall.subs :as subs]
            [machtfit.translation :refer [t]]
            [machtfit.utils :as utils]
            [re-frame.core :as rf]))

(rf/reg-sub ::onboarding-dismissed?
  :<- [:get [:stepchall :id]]
  :<- [:get [:ui :stepchall :flag-onboarding-dismissed?]]

  (fn [[stepchall-id intros-dismissed] _]
    (utils/in? intros-dismissed stepchall-id)))

(rf/reg-sub ::show-onboarding?
  :<- [:get [:stepchall :team-building-end]]
  :<- [:get [:clock :current-server-time]]
  :<- [::subs/is-team-member?]
  :<- [::onboarding-dismissed?]

  (fn [[team-building-end current-time is-team-member? onboarding-dismissed?] _]
    (and (< current-time team-building-end)
         (not is-team-member?)
         (not onboarding-dismissed?))))

(rf/reg-event-fx ::onboarding-close-clicked
  (fn [{:keys [db]} [_ scroll-to]]
    (let [stepchall-id (-> db :stepchall :id)
          intros-dismissed (-> db :ui :stepchall :flag-onboarding-dismissed?
                               ((fnil conj #{}) stepchall-id))]
      {:db (assoc-in db [:ui :stepchall :flag-onboarding-dismissed?] intros-dismissed)
       :scroll-to scroll-to})))

(defn onboarding []
  (when @(rf/subscribe [::show-onboarding?])
    (let [on-close-click #(rf/dispatch [::onboarding-close-clicked {:frame :app-frame
                                                                    :mode :page-top}])]
      [modal/modal {:title (t {:de "Willkommen zur machtfit-Challenge"
                               :en "Welcome to the machtfit-Challenge"})
                    :content [:p (t {:de "Mach dich bereit. Tritt einfach einem Team bei oder erstelle dein eigenes."
                                     :en "Get ready! To start please create a team or join an existing one."})]
                    :close-button {:on-click on-close-click}
                    :button-group [{:text (t {:de "Team erstellen"
                                              :en "Create a team"})
                                    :page {:id :stepchall
                                           :subpage :create-team}
                                    :style "sc_button-inline white sc_uppercase"}
                                   {:text (t {:de "Team beitreten"
                                              :en "Join a team"})
                                    :on-click #(rf/dispatch [::onboarding-close-clicked {:frame :app-frame
                                                                                         :mode :top
                                                                                         :subject ".sc_team-list"}])
                                    :style "white"}
                                   {:text (t {:de "Vielleicht später"
                                              :en "Do it later"})
                                    :on-click on-close-click
                                    :style "sc_button-inline white"}]
                    :modal-style "full-screen branded-bg left-aligned"}])))
